import script from "./ProductSheetModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSheetModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductSheetModal.vue?vue&type=style&index=0&id=c19558de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c19558de"]])

export default __exports__